export const COLORS = {
  primary: '#1C3045',
  primaryHover: '#2a4a63',
  primaryBgSubtle: 'rgba(28, 48, 69, 0.04)',
  primaryBgFaint: 'rgba(28, 48, 69, 0.02)',
  secondary: '#757575',
  border: '#e0e0e0',
  bodyText: '#424242',
  labelText: '#333',
  muted: '#9e9e9e',
  background: '#f8f9fa',
  white: '#ffffff',
  error: '#d32f2f',
  success: '#2e7d32',
  successBg: '#e8f5e9',
  lightGray: '#bdbdbd',
  subtleText: '#555',
  selectedBg: '#f5f8fa',
  hoverBg: '#fafafa',
  disabledBg: '#f5f5f5',
  link: '#1976d2',
  linkBgLight: 'rgba(25, 118, 210, 0.08)',
  focusBg: '#e8e8e8',
  disabledIcon: '#ccc',

  // Warning state
  warningBg: '#fff8e1',
  warningBorder: '#ffe082',
  warningIcon: '#f9a825',

  // Error alert state
  errorAlertBg: '#fff3f3',
  errorAlertBorder: '#ffcdd2',

  // Upload
  uploadDragActiveBg: '#f0f8ff',
} as const
